export default {
    data: () => ({
        orderHostessesColumns: [
            {
                label: "id",
                field: "id",
                sortable: true,
                required: true
            }, {
                label: "order status",
                field: "order_status.description",
                required: true,
                sortable: true
            }, {
                label: "order date",
                field: "created_at",
                required: true,
                sortable: true
            }, {
                label: "lending point",
                field: "lending_point.description",
                required: true
            }, {
                label: "lending kit",
                field: "lending_kit.identifier",
                required: true
            }, {
                label: "model",
                field: "lending_kit_model.description",
                required: true
            }, {
                label: "sku code",
                field: "lending_kit_color.sku",
                required: true
            }, {
                label: "sku description",
                field: "lending_kit_color.description",
                required: true
            }, {
                label: "image sku",
                field: "lending_kit_color.image",
                required: true
            }
        ]
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/orderHostessesColumns.js